export default "__VITE_ASSET__QMEj4ESk__"